class Render {
	constructor() {
		// Set up actions to return html
		this.data = [
			{
				class: ".woo-cart-qty",
				wrapper: ".woo-cart-qty",
				action: "cart_count",
			},
			{
				class: ".woo-message",
				wrapper: ".woo-messages",
				action: "woo_messages",
			},
		];

		// Run the renderer
		this.runRender();
	}

	/**
	 * Run the render function
	 */
	runRender() {
		// Post request to the render API
		fetch("/api/render", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(this.data),
		})
			.then((response) => response.json())
			.then((data) => {
				data.forEach((element) => {
					const htmlWrapper = document.querySelectorAll(element.wrapper);

					if (htmlWrapper) {
						htmlWrapper.forEach((wrapper) => {
							// Check for the message wrapper
							const messageWrapper = wrapper.closest(element.class) ? wrapper.closest(element.class) : wrapper.querySelector(element.class);

							// Reset
							wrapper.classList.remove("hidden");

							// Check to see if need to hide element
							if (element.html == "hide") {
								wrapper.classList.add("hidden");
							} else {
								// Remove Hidden Class
								wrapper.classList.remove("hidden");

								// Set HTMl to render
								messageWrapper.innerHTML = element.html;

								// If WooCommerce hide after 5s
								if (element.action == "woo_messages") {
									// setTimeout(() => {
									// 	wrapper.classList.add("hidden");
									// }, 6000);
								}
							}
						});
					}
				});
			})
			.catch((error) => {
				console.log(error);
			});
	}
}

// Close for Woo Messages
const close = document.querySelector(".js-close-messages");

if (close) {
	close.addEventListener("click", () => {
		document.querySelector(".woo-messages").classList.add("hidden");
	});
}

// Re run render on update
window.addEventListener("load", () => {
	jQuery(document.body).on("updated_cart_totals", () => {
		new Render();
	});

	jQuery(".woocommerce-cart-form .remove").on("click", () => {
		setTimeout(() => {
			new Render();
		}, 250);
	});
});

// Export Render class (for ES6 modules)
export default Render;
